import { useState } from "react";
import { FaEnvelope, FaTimes } from "react-icons/fa";
import emailjs from "emailjs-com";
import Loader from "../components/loader";
import "./PasswordRecoverPopup.css";

export default function PasswordRecoverPopup({ onCloseAll }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [responseMsg, setResponseMsg] = useState("");
  const isDarkMode = document.body.classList.contains("dark-mode");

  /* 🔑 DO NOT TOUCH EMAILJS LOGIC */
  const handleSubmit = (e) => {
    e.preventDefault();

    if (!email) {
      setResponseMsg("Please enter your email");
      return;
    }

    setLoading(true);
    setResponseMsg("");

    const token = crypto.randomUUID() + crypto.randomUUID();

    const link = `${process.env.REACT_APP_FRONTEND_URL}/rcp/${token}?email=${encodeURIComponent(
      email
    )}`;

    emailjs
      .send(
        "service_m7njlgc",
        "template_aerq6o3",
        { email, link },
        "TCjbbnvjH3UPcTWmK"
      )
      .then(() => {
        localStorage.setItem("recoverymail", email);
        setResponseMsg("Recovery email sent");
        setTimeout(onCloseAll, 1200);
      })
      .catch(() => setResponseMsg("Failed to send email"))
      .finally(() => setLoading(false));
  };

  return (
    <div className="recover-overlay" onClick={onCloseAll}>
      <div
        className="recover-modal-box"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="recover-modal-split">
          {/* LEFT PANEL */}
          <div className="recover-left-panel">
            <div className="recover-header">
              <div className="auth-brand">
                <img src="/image/trans-logo.png" alt="MarsMate" className="auth-brand-icon" />
                <span className="auth-brand-text">MARSMATE AI</span>
              </div>
              <h2 className="recover-title">Change Password</h2>
            </div>

            <div className="recover-card-wrapper">
              <form onSubmit={handleSubmit}>
                <div className="recover-input-group">
                  <FaEnvelope className="recover-input-icon" />
                  <input
                    type="email"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>

                <button
                  type="submit"
                  className="recover-btn"
                  disabled={loading}
                >
                  {loading ? "Sending..." : "Send Recovery Link"}
                </button>

                {loading && <Loader />}

                <p className="recover-response">{responseMsg}</p>
              </form>
            </div>
          </div>

          {/* RIGHT PANEL (IMAGE) */}
          <div className="recover-right-panel">
            <img
              src="/image/Recoveringimg.png"
              className="recover-illustration-img"
              alt="Recover"
            />
          </div>

          {/* CLOSE BUTTON */}
          <button
            className="recover-modal-close"
            onClick={onCloseAll}
          >
            <FaTimes />
          </button>
        </div>
      </div>
    </div>
  );
}
